import { render, staticRenderFns } from "./seeLicenseApplyszbjx.vue?vue&type=template&id=20a80a00&scoped=true&"
import script from "./seeLicenseApplyszbjx.vue?vue&type=script&lang=js&"
export * from "./seeLicenseApplyszbjx.vue?vue&type=script&lang=js&"
import style0 from "./seeLicenseApplyszbjx.vue?vue&type=style&index=0&id=20a80a00&scoped=true&lang=css&"
import style1 from "./seeLicenseApplyszbjx.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a80a00",
  null
  
)

export default component.exports